// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36Dw9","field":"styles_field__R5nGa","fieldCol":"styles_fieldCol__Zyca9","diffCol":"styles_diffCol__14iWU","diff":"styles_diff__1PrjE"};